<template>
  <ht-template-preview
    :template-key="key"
    :single="single"
    :task-type="taskType"
    :def-key="defKey"
    :data-view="dataView"
    :is-join-flow="isJoinFlow"
    :parameterq-querys="querys"
    :accept="accept"
    :custom-table-height="tableHeight"
  />
</template>

<script>
  import portal from '@/api/portal'
  import tableHeight from '@/mixins/tableHeight'
  export default {
    name: 'TemplatePreview',
    mixins: [tableHeight],
    props: {
      templateKey: {
        type: String,
        default: '',
      },
      parameterqQuerys: {
        type: String,
        default: '',
      },
      single: {
        type: String,
        default: '',
      },
      taskType: {
        type: String,
        default: '',
      },
      defKey: {
        type: String,
        default: '',
      },
      dataView: {
        type: Object,
        default: function () {
          return null
        },
      },
      isJoinFlow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        key: this.templateKey,
        querys: this.parameterqQuerys,
      }
    },
    computed: {
      accept() {
        return {
          downloadList: portal.sysAsyncEvent,
          downLoad: portal.downloadFileById,
          manualExecute: portal.manualExecuteEvent,
          delete: portal.deleteTaskById,
          deleteAll: portal.deleteTaskAll,
        }
      },
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        if (!this.key && this.$route.meta.templateKey) {
          this.key = this.$route.meta.templateKey
        }
        if (!this.parameterqQuerys && this.$route.params.parameterqQuerys) {
          this.querys = this.$route.params.parameterqQuerys
        }
      },
    },
  }
</script>
